import React from 'react';
import { Button, Input, LoadingSpinner } from '@vfit/shared/atoms';
import { ICommonData } from '@vfit/shared/models';
import { checkIsApp } from '@vfit/consumer/data-access';
import { useVoucherInsertionCard } from './voucherInsertionCard.hook';
import * as S from './voucherInsertionCard.style';
import { voucherCodeFieldName, voucherSchema } from './voucherInsertion.shema';
import { ButtonCBU } from '@vfit/consumer/components';

export const VoucherInsertionCard: React.FC<ICommonData> = () => {
  const { voucherCms, handleClick, errors, register, isLoading } = useVoucherInsertionCard();
  return (
    <S.CardFrame>
      {voucherCms?.voucherstwilight?.insertion?.title && (
        <S.Title>{voucherCms?.voucherstwilight?.insertion?.title}</S.Title>
      )}
      {voucherCms?.voucherstwilight?.insertion?.message && (
        <S.Message>{voucherCms?.voucherstwilight?.insertion?.message}</S.Message>
      )}
      <Input
        error={errors?.voucherCode?.message}
        label={voucherCms?.voucherstwilight?.insertion?.inputName}
        disabled={isLoading}
        {...register(voucherCodeFieldName, voucherSchema.voucherCode)}
      />
      <ButtonCBU disabled={isLoading} variant={'primary'} onClick={handleClick}>
        {voucherCms?.voucherstwilight?.insertion?.buttonLabel}
        {isLoading && (
          <S.Loading>
            <LoadingSpinner />
          </S.Loading>
        )}
      </ButtonCBU>
    </S.CardFrame>
  );
};

export default VoucherInsertionCard;
